import Datepicker from '@root/core/src/components/datepicker';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { toRgba } from '@root/joinroot.com/src/utils/colors';

export default function CovidDateRangeSelection({
  earliestDate,
  endDate,
  latestDate,
  setEndDate,
  setStartDate,
  startDate,
  trackClick,
  isDateDropdownOpen,
}) {
  const handleStartDateChange = (newValue) => {
    trackClick('START_DATE_CHANGED');
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue) => {
    trackClick('END_DATE_CHANGED');
    setEndDate(newValue);
  };

  return (
    <div css={[styles.dateInputsContainer, isDateDropdownOpen && styles.dropdownIsOpen]}>
      <Datepicker
        dateLimit={endDate}
        disablePastDays={true}
        inputId={'start-date'}
        label={'Start date'}
        onDateChange={handleStartDateChange}
        selectedDay={startDate}
        today={earliestDate}
        value={startDate}
      />
      <Datepicker
        dateLimit={latestDate}
        disablePastDays={true}
        inputId={'end-date'}
        label={'End date'}
        onDateChange={handleEndDateChange}
        selectedDay={endDate}
        today={startDate}
        value={endDate}
      />
    </div>
  );
}

CovidDateRangeSelection.propTypes = {
  earliestDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  isDateDropdownOpen: PropTypes.bool,
  latestDate: PropTypes.instanceOf(Date),
  setEndDate: PropTypes.func,
  setStartDate: PropTypes.func,
  startDate: PropTypes.instanceOf(Date),
  trackClick: PropTypes.func,
};

const zEase = 'cubic-bezier(0.165, 0.84, 0.44, 1)';

const styles = StyleSheet.create({
  dateInputsContainer: {
    position: 'absolute',
    top: '100%',
    right: 0,
    width: '100%',
    padding: '0 9px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: `transform 700ms ${zEase}, opacity 150ms ease-in-out`,
    opacity: 0,
    pointerEvents: 'none',
    transform: 'translate3d(0, 10px, 0)',
    ...Responsive.sm({
      maxWidth: 400,
      margin: '0 9px',
      padding: 10,
      backgroundColor: Colors.white(),
      borderRadius: 10,
      boxShadow: `0 6px 30px -4px ${toRgba(Colors.nearBlack(), 0.2)}`,
    }),
    '& > * + *': {
      marginTop: 10,
    },
  },
  dropdownIsOpen: {
    opacity: 1,
    pointerEvents: 'auto',
    transform: 'translate3d(0, 0, 0)',
  },
});
